// components/widgets/primitives/eyebrow.js
// ═══════════════════════════════════════════════════════════
// EYEBROW — uppercase mono label row, with parts separated by ·
// e.g. "current briefing · apr 21, 2026 · 35% confident"
// ═══════════════════════════════════════════════════════════

export default function Eyebrow({ parts = [], children, className = '' }) {
  // Accept either a parts array OR direct children text
  const text = children || parts.filter(Boolean).join(' · ');
  if (!text) return null;
  return (
    <div className={`ws-prim-eyebrow ${className}`}>
      {text}
    </div>
  );
}
